import React from 'react'

const Loader = () => {
    return (
        <div className='loaderWrapper'>
            <img src="/logob.png" style={{ width: '185px' }} alt="logo" />
        </div>
    )
}

export default Loader